export default "__VITE_ASSET__$W3_nU9Q__"